
import React from 'react'
import { Spin, Layout, Col, Row, PageHeader, Input, Button, Tooltip, Modal, List, Empty, message } from "antd";
import { CardOperations, CardSaldosGraph, CardOperationsList, CardDashboardKPI } from '../Widgets/Cards';
import { ReloadOutlined, UnorderedListOutlined, MoneyCollectOutlined, ArrowDownOutlined, ArrowUpOutlined, WalletOutlined, RiseOutlined, FallOutlined, LineChartOutlined } from "@ant-design/icons";
import '../../Styles/Modules/Dashboard/dashboard.css';

import moment from 'moment';
const axios = require('axios')

const { Content } = Layout;


export default class Dashboard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            loading_cambio: false,
            tipo_cambio_actual: 0,
            historial: [],
            page: 1,
            modal_visible: false,


            finanzas_saldos: 0,
            finanzas_ganancia: 0,
            finanzas_ganancia_pasado: 0,
            finanzas_gastos: 0,
            finanzas_gastos_pasado: 0,
            cuentas: [],
            rubros: [],

            /** Bloque de facturas emitidas que regresa el endpoint en data.facturacion */
            facturacion: {}

        }
    }



    /**
     *
     *
     * @memberof Dashboard
     * @description Carga los datos a la vista
     */
    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        this.getHistorialCambio();
        this.getDataDashboard();

    }
    /**
     *
     *
     * @memberof Dashboard
     * @description Consulta el historial de los tipos de cambios
     */
    getHistorialCambio = (page) => {
        let items = this.state.historial;

        this.setState({ loading_cambio: true })
        axios.get('/tipo-cambio', {
            params: {
                page: page
            }
        })
            .then(res => {
                const data = res.data.data.itemsList;
                this.setState({
                    historial: (page == 1) ? data : [...items, ...data],
                    tipo_cambio_actual: data.length > 0 ? data[0].valor.toFixed(2) : this.state.tipo_cambio_actual,
                    page: res.data.data.paginator.currentPage,
                    itemCount: res.data.data.paginator.itemCount,
                    pageCount: res.data.data.paginator.pageCount,

                })
            }
            )
            .catch(error => {
                console.log('error', error);
            })
            .finally(() => {
                this.setState({ loading_cambio: false })
            })
    }


    /**
     *
     *
     * @memberof Dashboard
     * @description Actualiza el tipo de cambio actual al hacer click al boton de refresh
     */
    updateTipoCambio = () => {
        let valor = this.state.tipo_cambio_actual;
        axios.post('/tipo-cambio/add', {
            valor: valor
        })
            .then(res => {
                message.success('Se ha actualizado el tipo de cambio');
                this.getHistorialCambio();
            })
            .catch(error => {
                message.error('Ha ocurrido un error al intentar actualizar el tipo de cambio');
                console.log('error al update tipo cambio', error);
            })


    }
    /**
     *
     *
     * @memberof Dashboard
     * @description Carga mas elementos al historial
     */
    onLoadMore = () => {
        let current = this.state.page;
        current = current + 1;
        this.getHistorialCambio(current);

    };


    /**
     *
     *
     * @memberof Dashboard
     * @description Abre o cierra el modal de historial
     */
    modalToogle = () => {
        let toogle = this.state.modal_visible;
        this.setState({ modal_visible: !toogle });
    }


    renderIcon = (index, valor) => {
        let next = index + 1;

        if (next < this.state.historial.length) {
            if (valor.toFixed(2) < this.state.historial[next].valor.toFixed(2)) {
                return <ArrowDownOutlined style={{ color: '#12A15C' }} />
            }
            else
                return <ArrowUpOutlined style={{ color: '#E0393E' }} />
        }
        return <MoneyCollectOutlined style={{ color: '#8C9BB3' }} />

    }




    /**
    * @memberof Dashboard
    *
    * @method getDataDashboard
    * @description Obtiene la información del dashboard
    */
    getDataDashboard = () => {

        this.setState({ loading: true })
        axios.get('/dashboard', {})
            .then(response => {
                var data = response.data;

                if (data.success) {
                    data = data.data;
                    this.setState({
                        finanzas_saldos: data.finanzas_saldos,
                        finanzas_ganancia: data.finanzas_ganancia,
                        finanzas_ganancia_pasado: data.finanzas_ganancia_pasado,
                        finanzas_gastos: data.finanzas_gastos,
                        finanzas_gastos_pasado: data.finanzas_gastos_pasado,
                        cuentas: data.cuentas,
                        rubros: data.rubros,

                        facturacion: data.facturacion ?? {},

                    })
                }
            }).catch(error => {
                console.log(error)
                message.error('Error al traer la información')
            }).finally(() => {
                this.setState({ loading: false })
            })
    }


    getTransacciones =  (tipo) => {

        let url = new URL(axios.defaults.baseURL + '/dashboard/csv')
        url.searchParams.set('Authorization', sessionStorage.getItem('token'))
        url.searchParams.set("tipo", tipo)
        window.open(url, '_blank');

    }



    render() {
        var { cuentas = [], rubros = [], tipo_cambio_actual } = this.state;

        /**
         * El endpoint no siempre regresa todos los montos, se normalizan a numero
         * para poder formatearlos sin validar en cada card
         */
        const monto = (valor) => Number(valor) || 0;

        const finanzas_saldos = monto(this.state.finanzas_saldos);
        const finanzas_ganancia = monto(this.state.finanzas_ganancia);
        const finanzas_ganancia_pasado = monto(this.state.finanzas_ganancia_pasado);
        const finanzas_gastos = monto(this.state.finanzas_gastos);
        const finanzas_gastos_pasado = monto(this.state.finanzas_gastos_pasado);

        const balance = finanzas_ganancia - finanzas_gastos;
        const balance_pasado = finanzas_ganancia_pasado - finanzas_gastos_pasado;

        /** Mes en curso con la primera letra en mayuscula, moment lo regresa en minusculas */
        const mes = moment().format('MMMM [de] YYYY');
        const periodo = mes.charAt(0).toUpperCase() + mes.slice(1);

        /**
         * Facturas emitidas, todo el bloque viene en data.facturacion y se compara
         * el mes en curso (actual) contra el mes inmediato anterior (anterior)
         */
        const facturacion = this.state.facturacion || {};
        const parametros = facturacion.parametros || {};
        const fact_actual = facturacion.resumen?.actual || {};
        const fact_anterior = facturacion.resumen?.anterior || {};

        const fact_total = monto(fact_actual.total_mxn);
        const fact_total_mp = monto(fact_anterior.total_mxn);
        const fact_cantidad = monto(fact_actual.cantidad);
        const fact_cantidad_mp = monto(fact_anterior.cantidad);

        /** Los receptores ya vienen ordenados por monto, solo se normalizan al formato del card */
        const fact_top_receptores = (facturacion.receptores || []).map(item => ({
            _id: item.rfc,
            nombre: item.nombre,
            monto: monto(item.actual?.total_mxn)
        }));

        const fact_razones_sociales = (facturacion.razones_sociales?.actual || []).map(item => ({
            name: item.nombre,
            value: monto(item.total_mxn)
        }));

        /** Periodo facturado, se muestra en el encabezado de la seccion */
        const fact_periodo = parametros.mes_actual
            ? `${moment(parametros.mes_actual, 'YYYY-MM').format('MMMM YYYY')} vs ${moment(parametros.mes_anterior, 'YYYY-MM').format('MMMM YYYY')}`
            : 'Mes en curso contra mes anterior';

        return (
            <>
                <Spin spinning={this.state.loading}>
                    <PageHeader
                        className="site-page-header custom-page-header"
                        title={
                            <Row className="width-100" justify="space-between" align="middle">
                                <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                    <span className="ant-page-header-heading-title">
                                        Dashboard <span className="dash-page-subtitle">{periodo} · Resumen general</span>
                                    </span>
                                    
                                </Col>
                                <Col xl={12} lg={12} md={24} sm={24} xs={24} className="dash-header-tools">
                                    <div className="dash-fx">
                                        <label className="label-tipo-cambio">Tipo de cambio</label>
                                        <div className="dash-fx-field">
                                            <Input
                                                className="input-tipo-cambio"
                                                prefix={"$"}
                                                suffix={"MXN"}
                                                value={`${tipo_cambio_actual}`}
                                                onChange={(e) => this.setState({ tipo_cambio_actual: e.target.value })}
                                            />
                                            <Tooltip title="Guardar tipo de cambio">
                                                <Button
                                                    type="primary"
                                                    className="btn-tipo-cambio"
                                                    loading={this.state.loading_cambio}
                                                    icon={<ReloadOutlined />}
                                                    onClick={this.updateTipoCambio}
                                                />
                                            </Tooltip>
                                        </div>
                                        <Tooltip title="Ver historial">
                                            <Button
                                                className="btn-tipo-cambio-ouline"
                                                onClick={this.modalToogle}
                                                icon={<UnorderedListOutlined />}
                                            />
                                        </Tooltip>
                                    </div>
                                </Col>
                            </Row>
                        }
                    />
                    <Content className="content-bg dash-content">

                        {/* Resumen del mes */}
                        <Row gutter={[16, 16]}>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                                <CardDashboardKPI
                                    label="Saldo en cuentas"
                                    total={finanzas_saldos}
                                    hint={`${cuentas.length} ${cuentas.length === 1 ? 'cuenta' : 'cuentas'} · ${finanzas_saldos.toDolar(tipo_cambio_actual)} usd`}
                                    icon={<WalletOutlined />}
                                    color="#2D348C"
                                    delta={false}
                                />
                            </Col>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                                <CardDashboardKPI
                                    label="Ingresos del mes"
                                    total={finanzas_ganancia}
                                    total_mp={finanzas_ganancia_pasado}
                                    tipo_cambio={tipo_cambio_actual}
                                    icon={<RiseOutlined />}
                                    color="#12A15C"
                                />
                            </Col>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                                <CardDashboardKPI
                                    label="Egresos del mes"
                                    total={finanzas_gastos}
                                    total_mp={finanzas_gastos_pasado}
                                    tipo_cambio={tipo_cambio_actual}
                                    icon={<FallOutlined />}
                                    color="#E0393E"
                                    inverted
                                />
                            </Col>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                                <CardDashboardKPI
                                    label="Balance del mes"
                                    total={balance}
                                    hint={`Mes anterior $ ${balance_pasado.toMoney(true)} mxn`}
                                    icon={<LineChartOutlined />}
                                    color={balance >= 0 ? "#12A15C" : "#E0393E"}
                                    delta={false}
                                />
                            </Col>
                        </Row>

                        {/* Finanzas */}
                        <div className="dash-section-head">
                            <span className="dash-section-bar" style={{ background: '#2D348C' }} />
                            <div>
                                <span className="dash-section-title">Finanzas</span>
                                <span className="dash-section-sub">Flujo del mes en curso</span>
                            </div>
                            <span className="dash-section-rule" />
                        </div>
                        <Row gutter={[16, 16]}>
                            <Col xxl={8} xl={8} lg={12} md={24} sm={24} xs={24}>
                                <CardSaldosGraph
                                    title="Saldos por cuenta"
                                    subtitle="Distribución del efectivo disponible"
                                    total={finanzas_saldos}
                                    data={cuentas}
                                    label="cuentas"
                                    tipo_cambio={tipo_cambio_actual}
                                />
                            </Col>
                            <Col xxl={8} xl={8} lg={12} md={24} sm={24} xs={24}>
                                <CardOperations
                                    title="Ingresos"
                                    subtitle="Cobrado en el mes en curso"
                                    total={finanzas_ganancia}
                                    total_mp={finanzas_ganancia_pasado}
                                    color="#12A594"
                                    tipo_cambio={tipo_cambio_actual}
                                    tipo="Transacciones"
                                    getTransacciones={() => this.getTransacciones("Transacciones")}
                                />
                            </Col>
                            <Col xxl={8} xl={8} lg={24} md={24} sm={24} xs={24}>
                                <CardOperationsList
                                    title="Egresos"
                                    subtitle="Pagado en el mes en curso"
                                    total={finanzas_gastos}
                                    total_mp={finanzas_gastos_pasado}
                                    dataTop={rubros}
                                    listTitle="Principales rubros"
                                    tipo_cambio={tipo_cambio_actual}
                                    inverted
                                />
                            </Col>
                        </Row>

                        {/* Facturas emitidas */}
                        <div className="dash-section-head">
                            <span className="dash-section-bar" style={{ background: '#12A594' }} />
                            <div>
                                <span className="dash-section-title">Facturas</span>
                                <span className="dash-section-sub">Facturas de ingreso emitidas · {fact_periodo}</span>
                            </div>
                            <span className="dash-section-rule" />
                        </div>
                        <Row gutter={[16, 16]}>
                            <Col xxl={8} xl={8} lg={12} md={24} sm={24} xs={24}>
                                <CardOperations
                                    title="Facturado este mes"
                                    subtitle="Facturas emitidas a clientes"
                                    total={fact_total}
                                    total_mp={fact_total_mp}
                                    detalle={`${fact_cantidad} ${fact_cantidad === 1 ? 'factura emitida' : 'facturas emitidas'} · ${fact_cantidad_mp} el mes anterior`}
                                    color="#2D348C"
                                    tipo_cambio={tipo_cambio_actual}
                                    tipo="Facturas"
                                    getTransacciones={() => this.getTransacciones("Facturas")}
                                />
                            </Col>
                            <Col xxl={8} xl={8} lg={12} md={24} sm={24} xs={24}>
                                <CardOperationsList
                                    title="Principales receptores"
                                    subtitle={`El top 5 concentra el ${monto(facturacion.concentracion?.top_5_porcentaje).toMoney(true)} % de lo facturado`}
                                    total={fact_total}
                                    dataTop={fact_top_receptores}
                                    listTitle="Facturado por receptor"
                                    mostrar_total={false}
                                />
                            </Col>
                            <Col xxl={8} xl={8} lg={24} md={24} sm={24} xs={24}>
                                <CardSaldosGraph
                                    title="Facturado por razón social"
                                    subtitle="Distribución entre razones sociales emisoras"
                                    total={fact_total}
                                    data={fact_razones_sociales}
                                    label="razones sociales"
                                    mostrar_total={false}
                                />
                            </Col>
                        </Row>
                    </Content>
                </Spin>
                <Modal
                    onCancel={this.modalToogle}
                    visible={this.state.modal_visible}
                    className="modal-historial"
                    title={<>
                        <span className="dash-modal-title">Historial de tipo de cambio</span>
                        <span className="dash-modal-sub">Últimos valores registrados y quién los actualizó</span>
                    </>}
                    footer={null}
                    maskClosable={true}
                    destroyOnClose={true} >
                    <List
                        size="small"
                        itemLayout="horizontal"
                        dataSource={this.state.historial}
                        locale={{
                            emptyText:
                                <Empty
                                    image={<MoneyCollectOutlined style={{ fontSize: 35, color: '#8C9BB3' }} />}
                                    imageStyle={{ height: 60, padding: '5px' }}
                                    description={<>No se ha registrado ningún valor</>}
                                />
                        }}
                        className="historial-tipo-cambio list-border-none"
                        pagination={{
                            current: this.state.page,
                            pageSize: 10,
                            total: this.state.itemCount,
                            position: 'bottom',
                            className: "flex-left",
                            size: 'small'

                        }}
                        loading={this.state.loading_cambio}
                        renderItem={({ _id, valor, usuario_id, createdAt }, index) => <List.Item>
                            <div className="dash-historial-row">
                                <span>{this.renderIcon(index, valor)}</span>
                                <span className="dash-historial-valor">$ {valor.toFixed(2)} <small>mxn</small></span>
                                <span className="dash-historial-usuario">{usuario_id?.nombre} {usuario_id?.apellido}</span>
                                <span className="dash-historial-fecha">{moment(createdAt).format('LLL')}</span>
                            </div>
                        </List.Item>}
                    />

                </Modal>
            </>
        )
    }
}
